import { FC } from 'react'
import { Menu, MenuItem } from '@cargomart/ui'
import { useNavigate } from '@tanstack/react-router'
import cn from 'classnames'
import { useActions } from 'hooks'
import { MENU_LINKS } from 'layouts/MainLayout/Header/constants'
import { profileInfoRoute } from 'modules/profile/routes'

import { MenuDropdown } from '../MenuDropdown'

import s from './MobileMenu.module.less'

export const MobileMenu: FC = () => {
  const { closeMobileSidebar } = useActions()

  const navigate = useNavigate()

  const handleNavigateToSettings = async () => {
    navigate({ to: profileInfoRoute.to, replace: true })
    closeMobileSidebar()
  }

  return (
    <div className={cn(s.mobileMenu, 'px-2')}>
      <Menu>
        <MenuItem className="!py-2 px-3" onClick={handleNavigateToSettings} title="Учётная запись" />
        <hr className="mx-1.5 my-1 h-[1px] bg-[#e0e2ec]" />
        <div className={s.bodyItems}>
          {MENU_LINKS.map(({ title, link }, index) => (
            <>
              <MenuItem
                key={index}
                className="!py-2 px-3"
                title={title}
                onClick={() => {
                  navigate({ to: link, replace: true })
                  closeMobileSidebar()
                }}
              />
            </>
          ))}
        </div>
      </Menu>
      <hr className="mx-1.5 my-1 h-[1px] bg-[#e0e2ec]" />
      <div className={s.footerItems}>
        <Menu>
          <MenuDropdown />
        </Menu>
      </div>
    </div>
  )
}
